import ReactCodeEditor from "src/components/CodeEditor";
import { CurrentExercise } from "src/components/containers/CurrentExercise";
import { CurrentMotions } from "src/components/containers/CurrentMotions";
import { ExerciseSidebarContainer } from "src/components/containers/ExerciseSidebar";

export function HomeView() {
  return (
    <>
      <header className="App-header">
        <p>Welcome to Vimcrobatics!</p>
      </header>
      <div style={{ display: "flex" }}>
        {/**Left side navigation */}
        <div className="sidebar" style={{ flex: 0.3 }}>
          <ExerciseSidebarContainer />
        </div>

        {/** Main view */}
        <div className="Exercise Content" style={{ flex: 0.7 }}>
          <CurrentExercise />

          <div style={{ minHeight: "15vh" }}>
            <form style={{ height: "100%" }}>
              <ReactCodeEditor />
            </form>
          </div>
          <CurrentMotions />
        </div>
      </div>
    </>
  );
}
